import { useContext } from 'react'
import { AppContext } from '../context/AppContextProvider'

const useCustomContext = () => {
    const customContext = useContext(AppContext)
    return customContext
}

export default useCustomContext